import { forwardRef, useState, useEffect } from "react";
import { icon } from "../functions/icons";
import { Spinner } from "./spinner";
import I from "@editorjs/link";
import { HorizontalLayout, VerticalLayout } from "../components/layout";

export function StandardButton({
  title,
  size = "medium",
  backgroundColor = "primary-600",
  textColor = "white",
  arrow,
  onClick,
  isDisabled,
  className,
  style,
  children,
  deleteIcon,
}) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      data-testid="button-standard"
      className={`${className} horizontal button-comp ${size}-button small-rounded standard-margin-left ${isDisabled && "disabled"}`}
      style={{
        ...style,
        backgroundColor: `var(--${backgroundColor})`,
        color: textColor === "unset" ? "" : `var(--${textColor})`,
      }}
    >
      {arrow === "left" && (
        <div data-testid="arrow-left" className="flex">
          {icon("arrow-left")}
        </div>
      )}
      {children}
      {title}
      {deleteIcon && (
        <div data-testid="delete-icon" className="delete-icon">
          {icon("trash")}
        </div>
      )}
      {arrow === "right" && (
        <div data-testid="arrow-right" className="flex">
          {icon("arrow-right")}
        </div>
      )}
    </button>
  );
}

export function GoBackButton({
  title,
  size,
  color,
  left,
  right,
  goBack,
  onClick,
  className,
}) {
  return (
    <button
      onClick={onClick || goBack}
      data-testid="button-goback"
      className={`${size} ${color} semi-bold horizontal button-comp medium-button small-rounded standard-margin ${className}`}
      style={{
        backgroundColor: "var(--primary-600)",
        color: "var(--white)",
      }}
    >
      {left && <div data-testid="arrow-left">{icon("arrow-left")}</div>}
      {title}
      {right && <div data-testid="arrow-right">{icon("arrow-right")}</div>}
    </button>
  );
}
export function NavButton({ title, active, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="button-nav"
      className={`horizontal ${
        !active && "grey-background-50"
      } button-comp small-rounded standard-margin-left ${
        active && "white-background-color standard-shadow"
      }`}
    >
      <p className={`medium-bold grey-600 ${active && "primary-600"}`}>
        {title}
      </p>
    </button>
  );
}
export function DeleteButton({ title, active, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="button-delete"
      className={`horizontal standard-border  button-comp white-background-color small-rounded`}
      style={{ borderColor: "#F1F3F5" }}
    >
      {icon("trash")}{" "}
      <p
        className={`medium-bold standard-text-margin grey-600 ${
          active && "primary-600"
        }`}
        style={{ color: "#F83B3B" }}
      >
        {title}
      </p>
    </button>
  );
}
export const IconButton = forwardRef(function IconButton(
  { icon2, size, color, onClick, className, iconButton = true, style },
  ref
) {
  return (
    <button
      style={{ ...style }}
      ref={ref}
      onClick={(event) => onClick(event)}
      data-testid="button-icon"
      className={`${size} ${color} ${className} ${iconButton && "icon-button"}`}
    >
      {icon(icon2, size)}
    </button>
  );
});
export function ModalButton({ title, active, onClick ,style}) {
  return (
    <button
      onClick={onClick}
      className={"modal-button primary-background-500 grey-100"}
      style={style}
    >
      {title}
    </button>
  );
}

export function MagicButton({ onClick, loading, className, style }) {
  return loading ? (
    <Spinner className={"magic-button"} size="small" />
  ) : (
    <IconButton
      style={style}
      onClick={onClick}
      IconButton={false}
      className={`magic-button ${className}`}
      icon2={"wand"}
      size={"1rem"}
      color={"primary-600"}
    />
  );
}

export function ButtonGroup({ buttons, size }) {
  return (
    <div className={`button-group ${size}`}>
      {buttons.map((button) => {
        return (
          <button
            data-testid="button-group"
            onClick={button.onClick}
            className={button.selected ? "selected" : ""}
            key={button.id}
          >
            {button.content}
          </button>
        );
      })}
    </div>
  );
}
export function ButtonGroupX({ buttons, size, onClick }) {
  return (
    <div className={`button-group ${size}`}>
      {buttons.map((button) => {
        return (
          <button
            data-testid="button-group"
            onClick={(event) =>{ event.stopPropagation(); onClick(button.action)}}
            className={button.selected ? "selected" : ""}
            key={button.id}
          >
            {button.content}
          </button>
        );
      })}
    </div>
  );
}
// export function ButtonGroup({ buttons, size, onClick }) {
//   return (
//     <div className={`button-group ${size}`}>
//       {buttons.map((button,index) => {
//         return (
//           <button
//             data-testid="button-group"
//             onClick={() => onClick(index)}
//             className={button.selected ? "selected" : ""}
//             key={button.id}
//           >
//             {button.content}
//           </button>
//         );
//       })}
//     </div>
//   );
// }
export function IconGroup({ icons, size = "medium", style }) {
  return (
    <div style={{ ...style }} className={`icon-group ${size}`}>
      {icons.map((icon) => (
        <button
          data-testid="icon-group"
          style={{
            borderLeft: "solid 1px var(--divider-border-color)",
            padding: ".3rem .8rem",
          }}
          key={icon.id}
          onClick={icon.onClick}
          className={`icon-button ${icon.selected ? "selected" : ""}`}
          title={icon.tooltip}
        >
          {icon.icon}
        </button>
      ))}
    </div>
  );
}

// export function DropdownButton({
//   content,
//   dropdown,
//   optionSelected,
//   onToggle,
//   isOpen,
//   classButton = "",
//   classContent = "",
//   dropdownStyle,
//   disabled = false,
//   buttonStyle,
//   width = "max-content",
//   marginLeft = "auto",
// }) {
//   const [droppedDown, setDroppedDown] = useState(false);

//   function setOption(id) {
//     setDroppedDown(false);
//     if (onToggle) onToggle(false);
//     optionSelected(id);
//   }

//   useEffect(() => {
//     setDroppedDown(isOpen);
//   }, [isOpen]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         !event.target.closest(".button-dropdown") &&
//         !event.target.closest(".dropdown-menu")
//       ) {
//         setDroppedDown(false);
//         if (onToggle) onToggle(false);
//       }
//     }

//     if (droppedDown) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [droppedDown, onToggle]);

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         position: "relative",
//         marginLeft: marginLeft,
//         width: { width },
//       }}
//     >
//       <button
//         data-testid="button-dropdown"
//         className={`${classButton} button-dropdown ${
//           droppedDown ? "active" : ""
//         }`}
//         onClick={() => {
//           if (disabled) return;
//           setDroppedDown(true);
//           if (!droppedDown) {
//             if (onToggle) onToggle(true);
//           } else {
//             if (onToggle) onToggle(false);
//           }
//         }}
//         style={buttonStyle}
//         disabled={disabled}
//       >
//         <span className="dropdown-content">{content}</span>
//         <span className={`dropdown-chevron ${droppedDown ? "open" : "closed"}`}>
//           {icon("chevron-down", 16)}
//         </span>
//       </button>
//       {droppedDown ? (
//         <>
//           <div
//             style={dropdownStyle}
//             className={`${classContent} dropdown-menu`}
//           >
//             {dropdown.map(function (option) {
//               return (
//                 <li
//                   key={option.id}
//                   className={option.selected ? "selected" : "dropdown-option"}
//                   onClick={() => setOption(option.id)}
//                 >
//                   {option.selected ? icon("check-small") : ""} {option.content}
//                 </li>
//               );
//             })}
//           </div>
//         </>
//       ) : (
//         ""
//       )}
//     </div>
//   );
// }

export function DropdownButton({
  content,
  dropdown,
  optionSelected,
  onToggle,
  isOpen,
  classButton = "",
  classContent = "",
  dropdownStyle,
  disabled = false,
  buttonStyle,
  width = "max-content",
  marginLeft = "auto",
}) {
  const [droppedDown, setDroppedDown] = useState(false);

  function setOption(id) {
    setDroppedDown(false);
    if (onToggle) onToggle(false);
    optionSelected(id);
  }

  useEffect(() => {
    setDroppedDown(isOpen);
  }, [isOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest(".button-dropdown") &&
        !event.target.closest(".dropdown-menu")
      ) {
        setDroppedDown(false);
        if (onToggle) onToggle(false);
      }
    }

    if (droppedDown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [droppedDown, onToggle]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        marginLeft: marginLeft,
        width: { width },
      }}
    >
      <button
        data-testid="button-dropdown"
        className={`${classButton} button-dropdown ${
          droppedDown ? "active" : ""
        }`}
        onClick={() => {
          if (disabled) return;
          setDroppedDown(true);
          if (!droppedDown) {
            if (onToggle) onToggle(true);
          } else {
            if (onToggle) onToggle(false);
          }
        }}
        style={buttonStyle}
        disabled={disabled}
      >
        <span className="dropdown-content">{content}</span>
        <span className={`dropdown-chevron ${droppedDown ? "open" : "closed"}`}>
          {icon("chevron-down", 16)}
        </span>
      </button>
      {droppedDown ? (
        <>
          <div
            style={dropdownStyle}
            className={`${classContent} dropdown-menu`}
          >
            {dropdown.map(function (option) {
              return (
                <li
                  key={option.id}
                  className={option.selected ? "selected" : "dropdown-option"}
                  onClick={() => setOption(option.id)}
                >
                  {option.selected ? icon("check-small") : ""} {option.content}
                </li>
              );
            })}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}


export function TaskDropdownButton({
  dropStyle,
  dropdown,
  setDropdownOptions,
  multiSelect = false,
  classButton = "",
  classContent = "",
  dropdownStyle,
  disabled = false,
  buttonStyle,
  optionStyle,
  title,
  titleStyle,
  onToggle,
  onChange,
  selectedId,
  isOpen,
}) {
  const selectOption = id => {
    const newDropdown = dropdown.map(option => {
      if (option.id !== id) return option;
      return { ...option, selected: multiSelect ? !option.selected : true };
    });

    if (!multiSelect) {
      newDropdown.forEach(option => {
        if (option.id !== id) option.selected = false;
      });

      onToggle?.(); 
    }
    setDropdownOptions?.(newDropdown)
    onChange?.(newDropdown.filter(o => o.selected));
  };

  const selectedOptions = dropdown.filter(o => o.selected);

  const buttonContent =
    selectedOptions.length > 0 ? (
      <span className="dropdown-selected">
        {selectedOptions.map((o, i) => (
          <span key={o.id}>
            {o.content}
            {i < selectedOptions.length - 1 && ", "}
          </span>
        ))}
      </span>
    ) : (
      title
        ? `Selecteer optie${multiSelect ? "s" : ""} ${title}`
        : `Selecteer optie${multiSelect ? "s" : ""}`
    );

  return (
    <VerticalLayout style={{ display: "unset" ,...dropStyle}}>
      <p className="small-text semi-bold" style={{ marginBottom: "0.25rem", ...titleStyle }}>
        {title}
      </p>

      <button
        data-testid="button-dropdown"
        className={`task-button-dropdown ${classButton} ${isOpen ? "active" : ""}`}
        onClick={onToggle}
        style={buttonStyle}
        disabled={disabled}
      >
        <span key={selectedOptions.map(o => o.id).join(",")} className="dropdown-content slide-in-content" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "10rem" }}>
          {buttonContent}
        </span>


      </button>

      <div
        style={dropdownStyle}
        className={`${classContent} task-dropdown-menu ${isOpen ? "open" : ""}`}
      >
        {dropdown.map(option => (
          <li
            key={option.id}
            className={`dropdown-option ${option.selected ? "selected" : ""}`}
            onClick={() => selectOption(option.id)}
            style={optionStyle}
          >
            {multiSelect && option.selected && (
              <span className="option-icon">{icon("check-small")}</span>
            )}
            {!multiSelect && option.selected && icon("check-small")}
            {option.content}
          </li>
        ))}
      </div>
    </VerticalLayout>
  );
}

export function CategoryButton({
  dropdown,
  setDropdownOptions,
  multiSelect = false,
  classButton = "",
  classContent = "",
  dropdownStyle,
  disabled = false,
  buttonStyle,
  optionStyle,
  title,
  titleStyle,
  onChange,
  selectedId,
  category,
}) {
const [open, setOpen] = useState(false);

  const toggle = () => setOpen(prev => !prev);

  const selectOption = id => {
    const newDropdown = dropdown.map(option => {
      if (option.id !== id) return option;
      return { ...option, selected: multiSelect ? !option.selected : true };
    });

    if (!multiSelect) {
      newDropdown.forEach(option => { if (option.id !== id) option.selected = false });
      setOpen(false);
    }

    setDropdownOptions?.(newDropdown)
    onChange?.(newDropdown.filter(o => o.selected));
  };

  const selectedOptions = dropdown.filter(o => o.selected);

  const buttonContent =
    selectedOptions.length > 0 ? (
      <span className="dropdown-selected">
        {selectedOptions.map((o, i) => (
          <span key={o.id}>
            {o.content}
            {i < selectedOptions.length - 1 && ", "}
          </span>
        ))}
      </span>
    ) : (
      title
        ? `Selecteer optie${multiSelect ? "s" : ""} ${title}`
        : `Selecteer optie${multiSelect ? "s" : ""}`
    );

  return (
    <VerticalLayout style={{ display: "unset" }}>
      <p className="small-text semi-bold" style={{ marginBottom: "0.25rem", ...titleStyle }}>
        {title}
      </p>

      <button
        data-testid="button-dropdown"
        className={`task-button-dropdown ${classButton} ${open ? "active" : ""}`}
        onClick={toggle}
        style={buttonStyle}
        disabled={disabled}
      >
        <span key={selectedOptions.map(o => o.id).join(",")} className="dropdown-content slide-in-content" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "10rem" }}>
          {buttonContent}
        </span>

        <span className={`dropdown-chevron ${open ? "open" : "closed"}`}>
          {icon("chevron-down", 16)}
        </span>
      </button>

      <div
        style={dropdownStyle}
        className={`${classContent} task-dropdown-menu ${open ? "open" : ""}`}
      >
        {category}
      </div>
    </VerticalLayout>
  );
}

export function MultiSelectDropdown({
  options = [],
  onChange,
  selectedIds = [],
  classButton = "",
  classContent = "",
  dropdownStyle,
  buttonStyle,
  content = "Select options",
  isOpen,
  onToggle,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(selectedIds);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest(".multi-dropdown") &&
        !event.target.closest(".multi-dropdown-menu")
      ) {
        setOpen(false);
        if (onToggle) onToggle(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onToggle]);

  const toggleOption = (id) => {
    let updated;
    if (selected.includes(id)) {
      updated = selected.filter((i) => i !== id);
    } else {
      updated = [...selected, id];
    }
    setSelected(updated);
    if (onChange) onChange(updated);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
      }}
      className="multi-dropdown"
    >
      <button
        data-testid="button-multidropdown"
        className={`${classButton} button-dropdown ${open ? "active" : ""}`}
        onClick={() => {
          if (disabled) return;
          setOpen(!open);
          if (onToggle) onToggle(!open);
        }}
        style={buttonStyle}
        disabled={disabled}
      >
        <span className="dropdown-content">{content}</span>
        <span className={`dropdown-chevron ${open ? "open" : "closed"}`}>
          {icon("chevron-down", 16)}
        </span>
      </button>

      {open && (
        <div
          style={dropdownStyle}
          className={`${classContent} multi-dropdown-menu dropdown-menu`}
        >
          {options.map((option) => (
            <li
              key={option.id}
              className={selected.includes(option.id) ? "selected" : ""}
              onClick={() => toggleOption(option.id)}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <span>
                {selected.includes(option.id)
                  ? icon("check-small")
                  : icon("blank")}
              </span>
              {option.content}
            </li>
          ))}
        </div>
      )}
    </div>
  );
}

export function FilterDropdown({ options = [],selectedIds = [], onChange, disabled = false, classButton = "", classContent = "", dropdownStyle = {}, buttonStyle = {}}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(selectedIds);

  useEffect(() => setSelected(selectedIds), [selectedIds]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest(".filter-dropdown") &&
        !event.target.closest(".filter-menu")
      ) {
        setOpen(false);
      }
    }

    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const toggleOption = (id) => {
    const updated = selected.includes(id)
      ? selected.filter((i) => i !== id)
      : [...selected, id];
    setSelected(updated);
    if (onChange) onChange(updated);
  };

  return (
    <div
      className="filter-dropdown"
      style={{
        position: "relative",
        display: "inline-flex",
        flexDirection: "column",
      }}
    >
      <IconButton
        icon2="filter"
        onClick={() => !disabled && setOpen(!open)}
        className={`${classButton} ${open ? "active" : ""} filter-button`}
        style={buttonStyle}
        disabled={disabled}
      />

      {open && (
        <div
          className={`dropdown-menu filter-menu ${classContent}`}
          style={{
            marginTop: "0.4rem",
            minWidth: "180px",
            ...dropdownStyle,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.id}
              className={selected.includes(opt.id) ? "selected" : "dropdown-option"}
              onClick={() => toggleOption(opt.id)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: ".5rem",
                cursor: "pointer",
              }}
            >
              {opt.label}
              {selected.includes(opt.id) ? icon("check-small") : icon("blank")}
            </li>
          ))}
        </div>
      )}
    </div>
  );
}